import React from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartOptions, ChartData } from "chart.js";
import moment from "moment";
import { Bar } from "react-chartjs-2";
import styles from "./util-admin-dashboard-chart.module.scss";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

/* =======================
   Types
======================= */

export interface UtilAdminDashboardChartItem {
	consumption: number;
	generatorName: string;
}

export type UtilAdminDashboardChartGroup = UtilAdminDashboardChartItem[];

export interface UtilAdminDashboardChartProps {
	startDate?: string; // DD-MM-YYYY
	endDate?: string; // DD-MM-YYYY
	data?: UtilAdminDashboardChartGroup[];
	transactionPurposeType?: string;
}

/* =======================
   Chart Options
======================= */
const options: ChartOptions<"bar"> = {
	maintainAspectRatio: false,
};

/* =======================
   Helpers
======================= */

function parseDate(dateString: string): boolean {
	const [month, dayStr] = dateString.split(" ");
	const day = parseInt(dayStr, 10);

	const today = new Date();
	const currentMonth = today.toLocaleString("default", { month: "short" });
	const currentDay = today.getDate();

	return month.toLowerCase() === currentMonth.toLowerCase().trim() && day === currentDay;
}

function getRandomColor(index: number): string {
	const colorList = ["rgb(78, 91, 166)", "rgb(105, 156, 255)", "rgb(246, 188, 115)", "rgb(124, 220, 165)", "rgb(249, 162, 66)"];

	if (index < colorList.length) {
		return colorList[index];
	}

	const red = Math.floor(Math.random() * 256);
	const green = Math.floor(Math.random() * 256);
	const blue = Math.floor(Math.random() * 256);

	return `rgb(${red},${green},${blue})`;
}

/* =======================
   Component
======================= */

const UtilAdminDashboardChart: React.FC<UtilAdminDashboardChartProps> = ({ startDate, endDate, data: inputData, transactionPurposeType }) => {
	const datasets: ChartData<"bar">["datasets"] = [];
	const dataLabels: string[] = [];

	if (startDate && endDate) {
		const currentDate = moment(startDate, "DD-MM-YYYY");
		while (currentDate.isSameOrBefore(moment(endDate, "DD-MM-YYYY"))) {
			dataLabels.push(currentDate.format("MMM DD"));
			currentDate.add(1, "day");
		}
	}

	if (inputData && inputData.length > 0) {
		inputData.forEach((group, index) => {
			if (group.length === 0) return;
			group.map(x => dataLabels.push(x.generatorName));
			datasets.push({
				label: transactionPurposeType,
				data: group.map(item => item.consumption),
				backgroundColor: "#489c1f",
				borderRadius: 100,
				maxBarThickness: 80,
			});
		});
	}

	const chartData: ChartData<"bar"> = {
		labels: dataLabels,
		datasets,
	};
	return (
		<div className={styles.ChartWrap}>
			<div className={styles.ChartC}>
				<Bar options={options} data={chartData} />
			</div>
		</div>
	);
};

export default UtilAdminDashboardChart;
